// extracted by mini-css-extract-plugin
export default {"gameFavoriteIcon":"GameFavoriteIcon__gameFavoriteIcon--2rf","gameFavoriteIconActive":"GameFavoriteIcon__gameFavoriteIconActive--Ox7"};